export const URL_METADATA_API_URL =
  'https://url-metadata-test.up.railway.app/api/url-metadata';
